import styled from 'styled-components';

const Banner = styled.div`
  position: sticky;
`;

const FormBody = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormDetails = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: stretch;
    gap: 8px;

    .review-details {
        display: flex;
        flex: 1 1 auto;

        @media (max-width: 1100px) {
            order: 2;
        }
    }

    .side-panel {
        width: 400px;

        @media (max-width: 1100px) {
            order: 1;
            width: 100%;
        }
    }

`;

export default {
    Banner,
    FormBody,
    FormDetails,
};
